import * as coord from '../../templates';

const TemplateSelector = (props) => {
    const { applyTemplate } = props;
    const style =
        'rounded-lg bg-gray-200 hover:bg-amber-500 hover:text-amber-900 text-gray-500 text-xs uppercase px-4 py-2';

    const templates = [
        { category: 'sticker', label: 'Zapatos', value: 'stickerZapatos' },
        { category: 'sticker', label: 'Redondo', value: 'stickerRedondo' },
        { category: 'sticker', label: 'Redondo2', value: 'stickerRedondo2' },
        { category: 'sticker', label: 'Cuadrado', value: 'stickerCuadrado' },
        { category: 'sticker', label: 'Cuadrado2', value: 'stickerCuadrado2' },
        { category: 'sticker', label: 'Cuaderno', value: 'stickerCuaderno' },
        { category: 'sticker', label: 'Grande', value: 'stickerGrande' },
        { category: 'sticker', label: 'Mediano', value: 'stickerMediano' },
        { category: 'sticker', label: 'Pequeño', value: 'stickerPequeno' },
        { category: 'sticker', label: 'Mini', value: 'stickerMini' },
        { category: 'ropa', label: 'Cuadrada', value: 'ropaCuadrada' },
        { category: 'ropa', label: 'Grande', value: 'ropaGrande' },
        { category: 'ropa', label: 'Pequeña', value: 'ropaPequena' },
        { category: 'ropa', label: 'Redonda', value: 'ropaRedonda' },
        { category: 'combo', label: 'Colegio', value: 'comboColegio' },
        { category: 'combo', label: 'Jardín', value: 'comboJardin' },
        { category: 'combo', label: 'Ropa', value: 'comboRopa' },
        { category: 'combo', label: 'Sticker', value: 'comboSticker' },
    ];

    const selectTemplate = (template) => {
        if (!template) return;
        if (
            window.confirm(
                `¿Desea aplicar las coordenadas de la plantilla ${template.category} ${template.label}?`
            )
        ) {
            let templateCoords = null;
            switch (template.value) {
                case 'stickerZapatos':
                    templateCoords = coord.stickerZapatosTemplate();
                    break;
                case 'stickerRedondo':
                    templateCoords = coord.stickerRedondoTemplate();
                    break;
                case 'stickerRedondo2':
                    templateCoords = coord.stickerRedondo2Template();
                    break;
                case 'stickerCuadrado':
                    templateCoords = coord.stickerCuadradoTemplate();
                    break;
                case 'stickerCuadrado2':
                    templateCoords = coord.stickerCuadrado2Template();
                    break;
                case 'stickerCuaderno':
                    templateCoords = coord.stickerCuadernoTemplate();
                    break;
                case 'stickerGrande':
                    templateCoords = coord.stickerGrandeTemplate();
                    break;
                case 'stickerMediano':
                    templateCoords = coord.stickerMedianoTemplate();
                    break;
                case 'stickerPequeno':
                    templateCoords = coord.stickerPequenoTemplate();
                    break;
                case 'stickerMini':
                    templateCoords = coord.stickerMiniTemplate();
                    break;
                case 'ropaCuadrada':
                    templateCoords = coord.ropaCuadradaTemplate();
                    break;
                case 'ropaGrande':
                    templateCoords = coord.ropaGrandeTemplate();
                    break;
                case 'ropaPequena':
                    templateCoords = coord.ropaPequenaTemplate();
                    break;
                case 'ropaRedonda':
                    templateCoords = coord.ropaRedondaTemplate();
                    break;
                case 'comboColegio':
                    templateCoords = coord.comboColegioTemplate();
                    break;
                case 'comboJardin':
                    templateCoords = coord.comboJardinTemplate();
                    break;
                case 'comboRopa':
                    templateCoords = coord.comboRopaTemplate();
                    break;
                case 'comboSticker':
                    templateCoords = coord.comboStickerTemplate();
                    break;

                default:
                    return false;
            }
            applyTemplate(templateCoords);
        }
    };

    return (
        <div className="lg:grid grid-cols-6 gap-2">
            {templates.map((template) => {
                return (
                    <button
                        key={template.value}
                        onClick={() => selectTemplate(template)}
                        className={style}
                    >
                        <span className="text-2xs block">{template.category}</span>
                        <span className="font-bold">{template.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default TemplateSelector;
